import type { Locale } from '@/i18n/locales'

/**
 * The currency every amount reaches this layer in. Facts, WAPI and psearch all quote
 * canonical amounts; a display currency exists only at render
 * (→ invariants.md#facts-canonical-store-editorial).
 */
export const CANONICAL_CURRENCY = 'USD'

/** The currencies this app is willing to state a price in. */
export const DISPLAY_CURRENCIES = ['USD', 'MXN'] as const

export type DisplayCurrency = (typeof DISPLAY_CURRENCIES)[number]

/**
 * Each served locale's default display currency — the served-locale rows of the shared
 * Wanderu locale→currency mapping, adopted rather than invented (spec RD-6). Repointing a
 * locale, or adding one, is a change to a convention other surfaces also apply: a visitor
 * moving between surfaces keeps their currency only because both read the same table.
 *
 * Typed on `Locale` so a new served locale is a compile error until someone decides which
 * currency it prices in, rather than silently falling back.
 */
export const LOCALE_DEFAULT_CURRENCY: Record<Locale, DisplayCurrency> = {
    'en-us': 'USD',
    'es-mx': 'MXN',
}

export function isDisplayCurrency(value: string): value is DisplayCurrency {
    return (DISPLAY_CURRENCIES as readonly string[]).includes(value)
}
